export default "__VITE_ASSET__CeKM3XjT__"